import { render, staticRenderFns } from "./HospitalsAdd.vue?vue&type=template&id=6ac41e2c&"
import script from "./HospitalsAdd.vue?vue&type=script&lang=js&"
export * from "./HospitalsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports